// get list of category
export const GET_CATEGORIES_PROCESS = "GET_CATEGORIES_PROCESS";
export const GET_CATEGORIES_SUCCESS = "GET_CATEGORIES_SUCCESS";
export const GET_CATEGORIES_FAIL = "GET_CATEGORIES_FAIL";
